import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
	selector: 'app-external-file-upload',
	templateUrl: './external-file-upload.component.html',
	styleUrls: ['./external-file-upload.component.scss']
})
export class ExternalFileUploadComponent implements OnInit {

	constructor(
		public commonService: CommonService
	) { }

	ngOnInit(): void {
	}

	@ViewChild('upload_input') upload_input;
	uploaded_file_name: any = "";
	upload_file_loader: boolean = false;


	uploadFile(event) {
		this.upload_file_loader = true;

		this.uploaded_file_name = event.target.files[0].name;

		const formData = new FormData();
		formData.append('file', event.target.files[0]);

		this.commonService.postData("/dailyfeedsupload/", formData).subscribe(
			(res: any) => {
				this.upload_file_loader = false;
				this.upload_input.nativeElement.value = '';
				this.uploaded_file_name = '';
				this.commonService.showToast('success', 'File Uploaded Successfully.');
			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.upload_file_loader = false;
				this.upload_input.nativeElement.value = '';
				this.uploaded_file_name = '';
			},
		);

	}

}
